var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"benefits-wrapper"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{staticClass:"router-view"})],1),_c('BenefitsNav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }